const envStats = [
  { icon: "ri-heart-line", value: "Thousands", label: "Make-A-Wish donations", sub: "supporting children's wishes" },
  { icon: "ri-recycle-line", value: "95%+", label: "Diverted from landfill", sub: "measured, not estimated" },
  { icon: "ri-leaf-line", value: "100%", label: "Licensed facilities", sub: "audited by our own team" },
  { icon: "ri-file-text-line", value: "Every job", label: "Waste transfer note issued", sub: "legally compliant always" },
];

const commitments = [
  {
    icon: "ri-heart-line",
    title: "Make-A-Wish Foundation",
    desc: "For every collection we complete, we make a donation to Make-A-Wish UK — helping grant life-changing wishes for seriously ill children. To date, we've supported over 43,920 donations.",
  },
  {
    icon: "ri-building-2-line",
    title: "Audited recycling partners",
    desc: "We don't just drop waste at the nearest transfer station. Every facility we use is vetted by our own sustainability team, re-assessed annually.",
  },
  {
    icon: "ri-route-line",
    title: "Optimised routing",
    desc: "Our dispatch system groups collections to minimise empty mileage. Shorter drives, less fuel, lower emissions — every single day.",
  },

];

export default function AboutEnvironment() {
  return (
    <section className="py-20" style={{ background: "rgb(246,250,246)" }}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-cl-lime/15 border-2 border-cl-lime/30 rounded-full px-4 py-1.5 mb-5">
            <span className="w-2 h-2 rounded-full bg-cl-lime inline-block"></span>
            <span className="text-cl-green font-black text-xs uppercase tracking-widest">Environment</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-cl-dark leading-tight mb-4">
            Sustainability isn&apos;t a feature.<br />
            <span className="text-cl-green">It&apos;s the whole point.</span>
          </h2>
          <p className="text-cl-dark/60 font-semibold text-base max-w-xl mx-auto leading-relaxed">
            We built Cleario because the rubbish removal industry was polluting — in every sense. Here&apos;s what we&apos;ve done about it.
          </p>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {envStats.map((s) => (
            <div key={s.label} className="bg-white rounded-3xl p-6 thick-border cartoon-shadow text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-cl-lime/20 mx-auto mb-4">
                <i className={`${s.icon} text-cl-green text-xl`}></i>
              </div>
              <p className="text-cl-dark font-black text-2xl mb-0.5">{s.value}</p>
              <p className="text-cl-dark font-black text-sm mb-1">{s.label}</p>
              <p className="text-cl-dark/50 text-xs font-semibold">{s.sub}</p>
            </div>
          ))}
        </div>

        {/* Photo + commitments */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="rounded-3xl overflow-hidden thick-border cartoon-shadow h-80 lg:h-[420px] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20beaming%20joyful%20child%20jumping%20with%20excitement%20holding%20a%20giant%20bright%20colourful%20wrapped%20gift%20box%20surrounded%20by%20floating%20confetti%20balloons%20and%20streamers%20in%20a%20warm%20cheerful%20room%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20warm%20amber%20lime%20green%20and%20bright%20primary%20colours%2C%20crisp%20storybook%20style%2C%20no%20text&width=800&height=700&seq=about-makewish-v30&orientation=portrait"
              alt="Make-A-Wish Foundation partnership"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex flex-col gap-5">
            {commitments.map((c) => (
              <div key={c.title} className="flex items-start gap-4 bg-white rounded-2xl p-5 thick-border cartoon-shadow-sm">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-cl-lime flex-shrink-0 thick-border">
                  <i className={`${c.icon} text-cl-dark text-base`}></i>
                </div>
                <div>
                  <h3 className="text-cl-dark font-black text-sm mb-1">{c.title}</h3>
                  <p className="text-cl-dark/60 text-xs font-semibold leading-relaxed">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
